<template>
  <Popup :isVisible="isVisible" size="large" @close="handleClose">
    <div v-if="selectedRecipe" class="recipe-detail-popup col__black">
      <div class="header__row row">
        <div class="header__left col-6">
          <!-- Recipe Title Section -->
          <div class="recipe-title-section">
            <p class="recipe-category">
              {{ selectedRecipe.detail?.tag || "Iced" }}
            </p>
            <h1
              class="recipe-main-title"
              v-html="selectedRecipe.detail?.title || selectedRecipe.name"
            ></h1>
            <p class="recipe-description">
              {{
                selectedRecipe.detail?.desc ||
                "An Iced Coconut Vanilla Mint Mocktail, perfect for the summertime."
              }}
            </p>
          </div>
        </div>
        <div class="header__right col-6">
          <ImageWrapper
            :src="selectedRecipe?.imagePath"
            :alt="selectedRecipe.name"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <!-- Time and Difficulty Info -->
          <div class="recipe-meta-info">
            <div class="recipe-meta-item">
              <div class="recipe-meta-icon">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M15 2.8125C8.30859 2.8125 2.8125 8.30859 2.8125 15C2.8125 21.6914 8.30859 27.1875 15 27.1875C21.6914 27.1875 27.1875 21.6914 27.1875 15C27.1875 8.30859 21.6914 2.8125 15 2.8125ZM15 25.3125C9.34375 25.3125 4.6875 20.6562 4.6875 15C4.6875 9.34375 9.34375 4.6875 15 4.6875C20.6562 4.6875 25.3125 9.34375 25.3125 15C25.3125 20.6562 20.6562 25.3125 15 25.3125Z"
                      fill="#BF936C"
                    />
                    <path
                      d="M19.6875 14.0625H15.9375V8.4375C15.9375 7.92188 15.5156 7.5 15 7.5C14.4844 7.5 14.0625 7.92188 14.0625 8.4375V15C14.0625 15.5156 14.4844 15.9375 15 15.9375H19.6875C20.2031 15.9375 20.625 15.5156 20.625 15C20.625 14.4844 20.2031 14.0625 19.6875 14.0625Z"
                      fill="#BF936C"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="30" height="30" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="recipe-meta-text">{{
                selectedRecipe.detail?.time
              }}</span>
            </div>

            <div class="recipe-meta-item">
              <div class="recipe-meta-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_149_34926)">
                    <path
                      d="M4.25684 12.921C2.12799 12.921 0.401855 11.2177 0.401855 9.11621C0.401855 7.01474 2.12764 5.31142 4.25684 5.31142C4.51994 5.31142 4.77687 5.33749 5.02522 5.38692C5.24716 2.59444 7.61339 0.396484 10.5 0.396484C13.3866 0.396484 15.7532 2.59444 15.9751 5.38726C16.2235 5.33783 16.4804 5.31142 16.7435 5.31142C18.8723 5.31142 20.5985 7.01474 20.5985 9.11621C20.5985 11.2177 18.8727 12.921 16.7435 12.921V19.6036H4.25684V12.921Z"
                      stroke="#BF936C"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.7432 17.1582H4.25684V19.604H16.7432V17.1582Z"
                      stroke="#BF936C"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_149_34926">
                      <rect width="21" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
              <span class="recipe-meta-text">{{
                selectedRecipe.detail?.difficulty || "Easy"
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <!-- what you need -->
          <div
            v-if="selectedRecipe.detail?.whatYouWant"
            class="what-you-need-section"
          >
            <h3 class="section-title" v-html="$t('recipe.whatYouNeed')"></h3>

            <!-- Machine Card -->
            <div
              v-if="selectedRecipe.detail.whatYouWant.machine"
              class="need-item"
            >
              <MachineCard
                :machine="selectedRecipe.detail.whatYouWant.machine"
                @addToCart="handleMachineAddToCart"
                :isVisible="isVisible"
              />
            </div>

            <!-- Capsule Card -->
            <div v-if="selectedRecipe.detail.whatYouWant.cap" class="need-item">
              <CapsuleCard
                :capsule="selectedRecipe.detail.whatYouWant.cap"
                :selectedTab="selectedTab"
                @addToCart="handleCapsuleAddToCart"
                :isVisible="isVisible"
              />
            </div>

            <!-- Recipe Section -->
            <div
              v-if="selectedRecipe.detail.whatYouWant.recipt"
              class="recipe-section"
            >
              <div class="recipe-ingredients-container">
                <div class="row g-2">
                  <div
                    v-for="(ingredient, index) in selectedRecipe.detail
                      .whatYouWant.recipt"
                    :key="index"
                    class="recipe-ingredient-item col-6"
                    :class="{
                      'full-width':
                        index ===
                          selectedRecipe.detail.whatYouWant.recipt.length - 1 &&
                        selectedRecipe.detail.whatYouWant.recipt.length % 2 ===
                          1,
                    }"
                  >
                    <div class="recipe-bullet"></div>
                    <p class="recipe-ingredient-text">{{ ingredient }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <!-- how to make -->
          <div
            v-if="selectedRecipe.detail?.howToMake"
            class="how-to-make-section"
          >
            <h3 class="section-title" v-html="$t('recipe.howToMake')"></h3>

            <div class="steps-container">
              <div
                v-for="(step, index) in selectedRecipe.detail.howToMake.steps"
                :key="index"
                class="step-item"
                :class="{ selected: selectedStepIndex === index }"
                @click="selectStep(index)"
              >
                <div class="step-number-container">
                  <span class="step-label" v-html="$t('recipe.step')"></span>
                  <span class="step-number">{{
                    String(index + 1).padStart(2, "0")
                  }}</span>
                </div>
                <div class="step-dot"></div>
                <div class="step-connecting-line"></div>
                <div class="step-content">
                  <p class="step-text">{{ step }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Debug JSON Display (temporary) -->
      <!-- <div class="recipe-json-display mt-4">
        <h5 class="fz-16 fw-semibold mb-2">{{ $t("recipe.jsonData") }}:</h5>
        <pre class="json-content">{{
          JSON.stringify(selectedRecipe, null, 2)
        }}</pre>
      </div> -->
    </div>
    <div v-else class="no-recipe-selected">
      <p class="text-center">{{ $t("recipe.noRecipeSelected") }}</p>
    </div>
  </Popup>
</template>

<script>
import Popup from "../molecules/Popup.vue";
import MachineCard from "../molecules/MachineCard.vue";
import CapsuleCard from "../molecules/CapsuleCard.vue";
import { ImageWrapper } from "~/components/";

export default {
  name: "RecipeDetailPopup",
  components: {
    Popup,
    MachineCard,
    CapsuleCard,
    ImageWrapper,
  },
  props: {
    selectedTab: {
      type: String,
    },
    /**
     * Controls the visibility of the recipe detail popup
     */
    isVisible: {
      type: Boolean,
      default: false,
    },
    /**
     * The selected recipe object containing recipe information
     */
    selectedRecipe: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      /**
       * Index of the currently selected step in how-to-make section
       */
      selectedStepIndex: null,
    };
  },
  methods: {
    /**
     * Handle popup close event
     * Emits close event to parent component
     */
    handleClose() {
      this.$emit("close");
    },
    /**
     * Handle machine add to cart event
     * Emits machineAddToCart event with machine data
     */
    handleMachineAddToCart(machineData) {
      this.$emit("machineAddToCart", machineData);
    },
    /**
     * Handle capsule add to cart event
     * Emits capsuleAddToCart event with capsule data
     */
    handleCapsuleAddToCart(capsuleData) {
      this.$emit("capsuleAddToCart", capsuleData);
    },
    /**
     * Select a specific step in the how-to-make section
     * Updates the selectedStepIndex to highlight the selected step
     * @param {number} index - The index of the step to select
     */
    selectStep(index) {
      this.selectedStepIndex = this.selectedStepIndex === index ? null : index;
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";

.content .app {
  // Recipe Detail Popup Styles
  .recipe-detail-popup {
    // max-width: rem(600);
    width: 100%;

    .header {
      &__row {
        align-items: center;

        @include media-breakpoint-down(xl) {
          align-items: flex-start;
          --bs-gutter-x: 12px;
        }
      }

      &__left {
        @include media-breakpoint-down(xl) {
          flex: 1;
        }
      }

      &__right {
        img {
          width: 100%;
          max-width: 25.5rem;
          margin-bottom: -25%;
        }

        @include media-breakpoint-down(lg) {
          flex: 0;
          flex-basis: 35%;
          max-width: rem(216);
          margin-bottom: 0;
        }
      }
    }

    .recipe-title-section {
      display: flex;
      flex-direction: column;
      gap: rem(15);
      align-items: flex-start;

      .recipe-category {
        font-weight: 500;
        font-size: rem(32);
        color: color(black);
        text-transform: uppercase;
        letter-spacing: rem(4.16);
        line-height: normal;
        margin: 0;
        min-width: 100%;

        @include media-breakpoint-down(md) {
          font-size: rem(14);
          letter-spacing: 1.4px;
        }
      }

      .recipe-main-title {
        font-weight: 800;
        font-size: rem(72);
        color: color(black);
        text-transform: uppercase;
        letter-spacing: rem(9.36);
        line-height: normal;
        margin: 0;
        min-width: 100%;

        @include media-breakpoint-down(md) {
          font-size: rem(24);
          letter-spacing: 2.4px;
        }
      }

      .recipe-description {
        font-weight: 400;
        font-size: rem(16);
        color: color(black);
        letter-spacing: rem(0.8);
        line-height: 1.2;
        margin: 0;
        width: rem(501);

        @include media-breakpoint-down(md) {
          width: 100%;
        }
      }

      .recipe-meta-info {
        display: flex;
        gap: rem(24);

        @include media-breakpoint-down(md) {
          gap: rem(12);
        }

        .recipe-meta-item {
          display: flex;
          gap: rem(4);
          align-items: start;

          .recipe-bullet {
            margin-top: rem(8);
          }

          .recipe-meta-icon {
            width: rem(30);
            height: rem(30);
            flex-shrink: 0;

            svg {
              width: 100%;
              height: 100%;
            }
          }

          .recipe-meta-text {
            font-weight: 400;
            font-size: rem(16);
            color: color(black);
            text-align: center;
            line-height: normal;
            height: rem(16);
          }
        }
      }
    }
  }

  .recipe-detail-popup {
    padding: rem(24);

    @include media-breakpoint-down(md) {
      padding-left: rem(14);
      padding-right: rem(14);
    }

    .recipe-title-section {
      margin-bottom: rem(24);
    }

    .recipe-category {
      font-size: rem(14);
      font-weight: 600;
      color: color(gray);
      text-transform: uppercase;
      letter-spacing: rem(1);
      margin-bottom: rem(8);
    }

    .recipe-main-title {
      font-size: rem(32);
      font-weight: 700;
      color: color(black);
      line-height: 1.2;
      margin-bottom: rem(16);

      @include media-breakpoint-down(md) {
        font-size: rem(28);
      }
    }

    .recipe-description {
      font-size: rem(16);
      font-weight: 400;
      color: color(darkGray);
      line-height: 1.4;
      margin-bottom: rem(24);
    }

    .recipe-meta-info {
      display: flex;
      align-items: center;
      gap: rem(32);
      margin-bottom: rem(24);

      // @include media-breakpoint-down(md) {
      //   flex-direction: column;
      //   gap: rem(16);
      // }
    }
    .recipe-meta-item {
      display: flex;
      align-items: center;
      gap: rem(12);

      .recipe-meta-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: rem(40);
        height: rem(40);

        svg {
          width: rem(30);
          height: rem(30);
        }
      }

      .recipe-meta-text {
        font-size: rem(16);
        font-weight: 600;
        color: color(black);
      }
    }

    .recipe-json-display {
      margin-top: rem(24);

      h5 {
        font-size: rem(16);
        font-weight: 600;
        color: color(black);
        margin-bottom: rem(8);
      }

      .json-content {
        background: color(white);
        border: rem(1) solid color(lightGray);
        border-radius: rem(4);
        padding: rem(12);
        font-family: "Courier New", monospace;
        font-size: rem(12);
        line-height: 1.4;
        color: color(black);
        white-space: pre-wrap;
        word-wrap: break-word;
        max-height: rem(300);
        overflow-y: auto;
        margin: 0;
      }
    }

    // What You Need Section Styles
    .what-you-need-section {
      margin-bottom: rem(32);

      .section-title {
        font-size: rem(24);
        font-weight: 700;
        color: color(black);
        text-transform: uppercase;
        letter-spacing: rem(1.5);
        margin-bottom: rem(24);
        line-height: 1.2;
      }

      .need-item {
        margin-bottom: rem(20);

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    // How to Make Section Styles
    .how-to-make-section {
      margin-bottom: rem(32);

      .section-title {
        font-size: rem(24);
        font-weight: 700;
        color: color(black);
        text-transform: uppercase;
        letter-spacing: rem(1.5);
        margin-bottom: rem(24);
        line-height: 1.2;
      }

      .steps-container {
        position: relative;
        display: flex;
        flex-direction: column;

        @include media-breakpoint-down(md) {
          margin-left: -20px;
          width: calc(100% + 30px);
        }
      }

      .step-item {
        position: relative;
        display: flex;
        align-items: flex-start;
        padding-bottom: rem(44);
        // cursor: pointer;
        transition: all 0.3s ease;
        overflow: hidden;

        &:last-child {
          margin-bottom: 0;

          // Hide connecting line for last step
          .step-connecting-line {
            display: none;
          }
        }

        // &.selected {
        //   .step-number-container {
        //     .step-label {
        //       color: color(brown);
        //       font-weight: 600;
        //     }

        //     .step-number {
        //       background-color: color(brown);
        //       color: color(white);
        //       font-weight: 600;
        //     }
        //   }

        //   .step-dot {
        //     background-color: color(brown);
        //   }

        //   .step-text {
        //     color: color(brown);
        //     font-size: rem(14);
        //     font-weight: 600;
        //   }
        // }

        .step-number-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: rem(1);
          width: rem(83);
          flex-shrink: 0;

          .step-label {
            font-size: rem(16);
            font-weight: 400;
            color: color(black);
            text-transform: uppercase;
            letter-spacing: rem(0.8);
            line-height: 1.2;
            white-space: nowrap;
            transition: all 0.3s ease;
          }

          .step-number {
            font-size: rem(32);
            font-weight: 400;
            color: color(black);
            letter-spacing: rem(1.6);
            line-height: 1.2;
            white-space: nowrap;
            transition: all 0.3s ease;
            margin-top: rem(2);
          }
        }

        .step-dot {
          position: absolute;
          left: rem(83);
          top: rem(21);
          width: rem(10);
          height: rem(10);
          background-color: #bf936c;
          border-radius: 50%;
          transition: all 0.3s ease;
        }

        .step-connecting-line {
          position: absolute;
          left: 5.5rem;
          top: 3.25rem;
          width: 1px;
          height: 100vh;
          background-color: #bf936c;
        }

        .step-content {
          // position: absolute;
          // left: rem(138);
          // top: rem(24);
          // width: rem(288);
          padding-top: rem(18);
          padding-left: rem(30);

          .step-text {
            font-size: rem(14);
            line-height: 1.5;
            font-weight: 500;
            color: #454545;
            letter-spacing: rem(0.28);
            margin: 0;
            transition: all 0.3s ease;
          }
        }
      }
    }

    // Recipe Section Styles
    .recipe-section {
      margin-bottom: rem(32);

      .recipe-section-title {
        font-size: rem(24);
        font-weight: 700;
        color: color(black);
        text-transform: uppercase;
        letter-spacing: rem(1.5);
        margin-bottom: rem(24);
        line-height: 1.2;
      }

      .recipe-ingredients-container {
        display: flex;
        flex-direction: column;
        gap: rem(16);
      }

      .recipe-ingredients-row {
        display: flex;
        flex-direction: column;
        gap: rem(16);
      }

      .recipe-ingredient-item {
        display: flex;
        align-items: center;
        gap: rem(10);
        // width: 100%;

        &.full-width {
          width: 100%;
        }

        .recipe-bullet {
          width: rem(10);
          height: rem(10);
          background-color: #bf936c;
          border-radius: 50%;
          flex-shrink: 0;
        }

        .recipe-ingredient-text {
          font-family: "Nespresso Lucas", sans-serif;
          font-size: rem(18);
          font-weight: 400;
          color: color(black);
          line-height: 1.6;
          margin: 0;
          // white-space: nowrap;
        }
      }

      @include media-breakpoint-down(md) {
        .recipe-ingredients-row {
          flex-direction: column;
        }

        .recipe-ingredient-item {
          width: 100%;

          .recipe-ingredient-text {
            font-size: rem(16);
            white-space: normal;
          }
        }
      }
    }
  }

  .no-recipe-selected {
    padding: rem(32);

    p {
      font-size: rem(16);
      color: color(gray);
    }
  }
}
</style>
